module.exports = __webpack_public_path__ + "static/media/tarra-h2h-logotype-l.5c67eb87.svg";